import styled from 'styled-components'
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { black } from '../../assets/ui/colors';

const CustomDialogActions = styled(DialogActions)`
    & button {
        color: white;
    }
    & button.MuiButton-textSecondary {
        background: white;
        color: ${black};
    }
`;

const ConfirmPayTypeModal = ({
    open,
    handleConfirm,
    handleClose
}) => {

    return (
        <Dialog
            // fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">{"Вы действительно хотите записаться на прием по наличному расчету?"}</DialogTitle>
            <CustomDialogActions>
                <Button onClick={handleClose} color="secondary">
                    Нет
                </Button>
                <Button onClick={handleConfirm} color="secondary" variant='contained' autoFocus>
                    Да
                </Button>
            </CustomDialogActions>
        </Dialog>
    )
}

export default ConfirmPayTypeModal;
